import secureLocalStorage from "react-secure-storage";
import { CircularProgress, Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { Popup } from "@progress/kendo-react-popup";
import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/Scenario.scss";
import ColumnMenuFilter from "../Dashboard/ColumnMenuFilter";
import { CustomFieldSearchMenu } from "../Dashboard/CustomFieldSearchMenu";
import HistogramChart from "../Dashboard/HistogramChart";
import OrganizationTreeList from "../Dashboard/OrganizationTreeList";
import { SearchMenu } from "../Dashboard/SearchMenu";
import TornadoChart from "../Dashboard/TornadoChart";
import CurrencyFormat from "./Component/CurrencyFormat";
import ExistingControlCell from "./Component/ExistingControlCell";
import FrequencyComponentFoScenario from "./Component/FrequencyComponentFoScenario";
import GridExpandComponent from "./Component/GridExpandCompoent";
import NumericComponentForScenario from "./Component/NumericComponentForScenario";
import OverallComponenant from "./Component/OverallComponenant";
import PrePostComponenant from "./Component/PrePostComponenant";
import RiskCauseCell from "./Component/RiskCauseCell";
import RiskDescriptionCell from "./Component/RiskDescriptionCell";
import StatusComponent from "./Component/StatusComponent";
import { MitigationExpandForScenaio } from "./MitigationExpandForScenaio";
import { Renderers } from "./Renderers";
import * as moment from "moment";
import { formatNumber } from "@telerik/kendo-intl";
import FullTornadoChart from "../Dashboard/FullTornadoChart";
import { mapTree } from "@progress/kendo-react-treelist";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
const newApprovalIds = [];
class Scenario extends Component {
  Percentile = [
    "P5",
    "P10",
    "P15",
    "P20",
    "P25",
    "P30",
    "P35",
    "P40",
    "P45",
    "P50",
    "P55",
    "P60",
    "P65",
    "P70",
    "P75",
    "P80",
    "P85",
    "P90",
  ];
  Iteration = [100, 500, 1000, 5000, 10000];

  lastSelectedIndex = 0;
  constructor(props) {
    super(props);
    this.openSidebar = this.openSidebar.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.state = {
      riskList: [],
      riskTemp: [],
      OrgUnitIds:[],
      loader: false,
      openScenarioModelFlag: false,
      expandedRowList: [],
      editField: undefined,
      changes: "No",
      activeLink: null,
      selectedColumn: undefined,
      customFieldsmaster: [],
      filter: {
        logic: "and",
        filters: [],
      },
      existingFilter: [],
      riskTypemaster: [],

      sort: [],
      take: Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      showRiskDataSet: false,
      riskCountMonteCarlo: {},
      openSiderBar: false,
      impactGridData: [],
      scenarioList: [],
      editFlag: false,
      selectedIds: [],
      riskDatasetList: [],
      HeatMapConfigDataOpportunity: [],
      HeatMapConfigDataThreat: [],
      dynamicHeatmapProbabilityRange: [],
      isCustomFieldDeleted:false,
      isImpactDeleted:false,
      notValidPrimeDataset:false,
      primeHideFlag:secureLocalStorage.getItem("isPrime")==true?true:false,
      showscenario:false,
      // Individual display options for each chart section
      postMitigatedThreatTornadoOption: "top10",
      newScenarioThreatTornadoOption: "top10",
      realisedOpportunityTornadoOption: "top10",
      newScenarioOpportunityTornadoOption: "top10",
      postMitigatedThreatFullTornadoOption: "top10",
      newScenarioThreatFullTornadoOption: "top10",
      realisedOpportunityFullTornadoOption: "top10",
      newScenarioOpportunityFullTornadoOption: "top10"
        };
    this.renderers = new Renderers(this.enterEdit, this.exitEdit, "inEdit");
    
    // Helper functions to filter tornado data based on radio button selection
    this.getFilteredTornadoData = this.getFilteredTornadoData.bind(this);
    this.getFilteredFullTornadoData = this.getFilteredFullTornadoData.bind(this);
  }
  
  // Helper function to filter tornado data based on radio button selection
  getFilteredTornadoData(data, option) {
    if (!data) return [];
    
    // Check if data is an array
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return [];
    }
    
    // Make a deep copy to avoid modifying the original data
    const dataCopy = JSON.parse(JSON.stringify(data));
    
    // Sort the data by absolute value (magnitude) in descending order
    const sortedData = dataCopy.sort((a, b) => {
      const absA = Math.abs(parseFloat(a.value) || 0);
      const absB = Math.abs(parseFloat(b.value) || 0);
      if (absA < absB) return 1;
      if (absA > absB) return -1;
      return 0;
    });
    
    // Return all data or just the top 10 based on the option
    return option === "all" ? sortedData : sortedData.slice(0, 10);
  }
  
  // Helper function to filter full tornado data based on radio button selection
  getFilteredFullTornadoData(data, option) {
    if (!data) return [];
    
    // Check if data is an array
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return [];
    }
    
    // Make a deep copy to avoid modifying the original data
    const dataCopy = JSON.parse(JSON.stringify(data));
    
    // Sort the data by absolute value (magnitude) in descending order
    const sortedData = dataCopy.sort((a, b) => {
      const absA = Math.abs(parseFloat(a.max - a.min) || 0);
      const absB = Math.abs(parseFloat(b.max - b.min) || 0);
      if (absA < absB) return 1;
      if (absA > absB) return -1;
      return 0;
    });
    
    // Return all data or just the top 10 based on the option
    return option === "all" ? sortedData : sortedData.slice(0, 10);
  }
  componentDidMount() {
    this.isAuthorizeUse();
  }
  ToggleRiskDataset = () => {
    this.setState({ showRiskDataSet: !this.state.showRiskDataSet });
  };
  TogglescenarioDataset =() =>{
    this.setState({ showscenario: !this.state.showscenario });
  }

  isAuthorizeUse = async () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (this.props.match.params.id) {
        this.props.history.push({
          pathname: `/tenant/${this.props.match.params.id}`,
        });
      } else {
        this.props.history.push({
          pathname: "/",
        });
      }
    } else {
      await this.getOrganizationsUnits();
      this.getScenarioList();
      this.getRiskTypeList();
      this.getCustomField();
      this.getRiskDataSource();
      this.getMatrixColorCodes();
    }
  };

  getRiskDataSource = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
        Type: "Risk",
      };
      // this.setState({ ...this.state, loader: true });
      let response = await Api.getView(request);
      if (response.status === 200) {
        var datasource = response.datasource;
        this.setState({
          ...this.state,
          riskDatasetList: datasource,
        });
      } else {
        // this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  GetSingleuser = async () => {
    var request = {
      UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
    };
    this.setState({ ...this.state, loader: true });
    let response = await Api.GetSingleuser(request);
    if (response.status === 200) {
      this.setState({ ...this.state, loader: false });
      if (response.tenantUsers && response.tenantUsers.length > 0) {
        secureLocalStorage.setItem("role", response.tenantUsers[0].role);
      }
    } else {
      this.setState({ ...this.state, loader: false });
    }
  };

  getRiskTypeList = async () => {
    var typeList = [];
    try {
      let response = await Api.getRiskType();
      if (response.status === 200 && response.riskTypes) {
        for (var i = 0; i < response.riskTypes.length; i++) {
          if (response.riskTypes[i].name && response.riskTypes[i].name !== "") {
            typeList.push({
              id: response.riskTypes[i].riskTypeId,
              name: response.riskTypes[i].name,
              checked: false,
              hashValue: this.convertStrToHash(response.riskTypes[i].name),
            });
          }
        }
        let newFirstElement = {
          value: "undefined",
          text: "undefined",
          id: 0,
          name: " [blank]",
          checked: false,
          hashValue: "undefined",
          }
        typeList = [newFirstElement].concat(typeList);
        this.setState({
          ...this.state,
          riskTypemaster: [...typeList],
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getCustomField(request);
      if (response.status === 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = this.convertStrToHash(item1.possibleValues);
            return item1;
          });
          if(item.inputType=="Multi Drop Down"){
            let newFirstElement = {
              "hashValue":"",
              "id": 0,
              "possibleValues": " [blank]",
            }
            item["cfPossibleValues"] = [newFirstElement].concat(item.cfPossibleValues);
            item["possibleValues"]=[" [blank]"].concat(item.possibleValues);
          }
          return item;
        });

        this.setState({
          ...this.state,
          customFieldsmaster: [...response.customFields],
        });
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };

  openSidebar(val) {
    if (!this.state.openSiderBar) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    this.setState({ ...this.state, openSiderBar: !val });
  }

  getScenarioList = async () => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getSavedScenario(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          scenarioList: response.scenarioResponse,
        });
      } else {
        this.setState({
          ...this.state,
          scenarioList: [],
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false, scenarioList: [] });
      console.error(error);
    }
  };

  selectScenario = async (item) => {
    try {
      this.getImpactList(item.orgIds);
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        SavedScenarioId: item.id,
      };
      this.setState({ ...this.state, loader: true });
      this.setState({ activeLink: item.id });
      let response = await Api.GetSavedScenarioRisk(request);
      if (response.status === 200) {
        response.riskRegister.map((riskReg) => {
          riskReg["expanded"] = false;
          riskReg["frequency"] = riskReg.scenarioFrequency;
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.createdDate) {
            riskReg.createdDate = new Date(riskReg.createdDate);
            
          }

          if (riskReg.riskTypeNames) {
            let hashArr = this.stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );

            riskReg["riskTypeNames"] = hashArr;
          }else{
            riskReg["riskTypeNames"] = "undefined";
            riskReg["riskTypeNamesExport"]="";
          }
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
          return riskReg;
        });
        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }
        this.setState({ ...this.state, impactMaster: impactMaster });
        await this.createDynamicDropdowns(response.riskRegister);
        await this.constructImpactApprovalData(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);

        let riskData = response.riskRegister.map((dataItem) =>
          Object.assign(
            {
              selected: item.existingApprRiskIds.includes(
                dataItem.riskRegisterId
              ),
            },
            dataItem
          )
        );
let impact=this.state.impactslist.find((imp)=>imp.name===item.impact);
        this.setState({
          ...this.state,
          riskList: riskData,
          riskTemp: riskData,
          loader: false,
          mitigatedTornodoResponse: [],
          nonmitigatedTornodoResponse: [],
          mitigatedHistogramResponse: [],
          nonmitigatedHistogramResponse: [],
          nonMitigatedMonteCarloResponse: [],
          editFlag: true,
          SavedScenarioId: item.id,
          Iteration: item.iteration,
          Impact: impact,
          Name: item.name,
          Description: item.description,
          OrgUnitIds: item.orgIds,
          filter: {
            logic: "and",
            filters: [],
          },
        });
        await this.saveSelectedIds(riskData);
        this.refs.child.refreshData(item.orgIds);
        await this.runMonteCarleForExistingData(item);
      } else {
        this.setState({
          ...this.state,
          loader: false,

          Iteration: 1000,
          Impact: "",
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  handleOutsideClick(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.openSidebar(this.state.openSiderBar);
  }

  openScenarioPopup = () => {
    this.setState({
      ...this.state,
      openScenarioModelFlag: true,
    });
  };
  closeScenarioPopup = () => {
    this.setState({
      ...this.state,
      openScenarioModelFlag: false,
    });
  };

  getOrganizationsUnits = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getOrgUnits(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          data: response.organisationUnit,
          loader: false,
          Iteration: 1000,
        });
      } else {
        this.setState({
          ...this.state,
          data: [],
          Iteration: 1000,
          loader: false,
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false, Iteration: 1000 });
      console.error(error);
    }
  };
  getMatrixColorCodes = async () => {
    try {
      // var req = {
      //   WorkstreamId: 0,
      // };
      let response = await Api.MatrixColor();
      if (response.status === 200) {
       // normal,opportunity
       let normal_opp = response.matrixColor.find(
        (item) => item.riskType === "opportunity"
      );
      let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

      //  normal,threat
      let normal_threat = response.matrixColor.find(
        (item) => item.riskType === "threat"
      );
      let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);
      this.setState({
        
        HeatMapConfigDataThreat: threat_colorJsonData,
        HeatMapConfigDataOpportunity: opp_colorJsonData,

        heatMapCount: response.heatmapCount,
        dynamicHeatmapProbabilityRange:
          response.dynamicHeatmapProbabilityRange,
      });
      }
    } catch (error) {
      console.error(error);
    }
  };
  getRiskList = async (orgUnitListIds) => {
    if (orgUnitListIds && orgUnitListIds.length > 0) {
      await this.getRiskListByOrgUnitIds(orgUnitListIds);
      await this.getImpactList(orgUnitListIds);
      // let primeHideFlag = secureLocalStorage.getItem("isPrime")==true?true:false;
      // if(primeHideFlag){
      //   let arr=[];
      //   mapTree(this.state.data, "children", (item) => {
      //     if (orgUnitListIds.includes(item.unitId)) {
      //       if (item.isPrime) {
      //         primeHideFlag = item.isPrime;
      //         arr.push(true);
      //       }
      //     }
      //     return item;
      //   });
      //   primeHideFlag=arr.includes(true)?true:false;
      // }

      let primeHideFlag = secureLocalStorage.getItem("isPrime")==true?true:false;
      mapTree(this.state.data, "children", (item) => {
        if (orgUnitListIds.includes(item.unitId)) {
          if (!item.isPrime) {
            primeHideFlag = item.isPrime;
          }
        }
        return item;
      });
     
      this.setState({
        ...this.state,
        OrgUnitIds: orgUnitListIds,
        expandedRowList: [],
        existingFilter: [],
        sort: [],
        primeHideFlag:primeHideFlag,
        Impact:null
      });
    }
  };

  setEmptyRiskList = async (ids) => {
    this.setState({
      ...this.state,
      Impact:null,
      Percentile:"P50",
      Iteration:1000,
      riskList: [],
      riskTemp: [],
      selectedIds: [],
      OrgUnitIds: [],
      existingFilter: [],
      sort: [],
      mitigatedHistogramResponse: {},
      nonMitigatedMonteCarloResponse: {},
      mitigatedTornodoResponse: [],
      nonmitigatedTornodoResponse: [],
      mitigatedTornodoResponseOpportunity: {},
      mitigatedHistogramResponseOpportunity: {},
      nonmitigatedTornodoResponseOpportunity: [],
      nonmitigatedHistogramResponseOpportunity: [],
      nonMitigatedFullTornodoResponses: [],
      mitigatedFullTornodoResponses: [],
      nonMitigatedOppFullTornodoResponses: [],
      mitigatedOppFullTornodoResponses: [],
    });
  };
  getRiskListByOrgUnitIds = async (idList) => {
    try {
      var request = {
        OrgUnitIds: idList,
      };
      this.setState({
        ...this.state,
        loader: true,
        viewId: 0,
        OrgUnitIds: idList,
      });
      let response = await Api.getScenarioRisksByOrgIds(request);
      if (response.status === 200) {
        response.riskRegister.map((riskReg) => {
          riskReg["expanded"] = false;
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          
          if (riskReg.createdDate) {
            // riskReg.createdDate = new Date(riskReg.createdDate);
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.riskTypeNames) {
            let hashArr = this.stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );

            riskReg["riskTypeNames"] = hashArr;
          }else{
            riskReg["riskTypeNames"] = "undefined";
            riskReg["riskTypeNamesExport"]="";
          }
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Close";
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
          return riskReg;
        });
        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }
        this.setState({ ...this.state, impactMaster: impactMaster });
        await this.constructImpactApprovalData(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);
        await this.createDynamicDropdowns(response.riskRegister);
        var riskData = response.riskRegister.map((dataItem) =>
          Object.assign({ selected: true }, dataItem)
        );

        this.setState({
          ...this.state,
          riskList: riskData,
          riskTemp: riskData,
          loader: false,
          mitigatedHistogramResponse: {},
          nonMitigatedMonteCarloResponse: {},
          mitigatedTornodoResponse: [],
          nonmitigatedTornodoResponse: [],
          mitigatedTornodoResponseOpportunity: {},
          mitigatedHistogramResponseOpportunity: {},
          nonmitigatedTornodoResponseOpportunity: [],
          nonmitigatedHistogramResponseOpportunity: [],
          nonMitigatedFullTornodoResponses: [],
          mitigatedFullTornodoResponses: [],
          nonMitigatedOppFullTornodoResponses: [],
          mitigatedOppFullTornodoResponses: [],
          filter: {
            logic: "and",
            filters: [],
          },
        });
        await this.saveSelectedIds(riskData);
      } else {
        this.setState({
          ...this.state,
          riskList: [],
          riskTemp: [],
          loader: false,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        ...this.state,
        riskList: [],
        riskTemp: [],
        loader: false,
      });
    }
  };

  refreshRiskList = async (mitiData) => {
    try {
      if (mitiData.inEdit === "newApproval") {
        if (newApprovalIds.length > 0) {
          let perviousValue = newApprovalIds.findIndex(
            (item) => mitiData.riskRegisterActionId === item.id
          );
          if (perviousValue !== -1) {
            newApprovalIds[perviousValue].id = mitiData.riskRegisterActionId;
            newApprovalIds[perviousValue].newApproval =
              mitiData.newApproval.value;
          } else {
            newApprovalIds.push({
              id: mitiData.riskRegisterActionId,
              newApproval: mitiData.newApproval.value,
            });
          }
        } else {
          newApprovalIds.push({
            id: mitiData.riskRegisterActionId,
            newApproval: mitiData.newApproval.value,
          });
        }
      }
      var request = {};
      if (this.state.viewId && this.state.viewId !== 0) {
        request = {
          ViewId: this.state.viewId,
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        };
      } else {
        request = {
          OrgUnitIds: this.state.OrgUnitIds,
        };
      }
      let response =
        this.state.viewId && this.state.viewId !== 0
          ? await Api.getByViewId(request)
          : await Api.getScenarioRisksByOrgIds(request);
      if (response.status === 200) {
        response.riskRegister.map((riskReg) => {
          riskReg["expanded"] = false;
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.riskTypeNames) {
            let hashArr = this.stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );

            riskReg["riskTypeNames"] = hashArr;
          }else{
            riskReg["riskTypeNames"] = "undefined";
            riskReg["riskTypeNamesExport"]="";
          }
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Close";
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
          //get existing new frequency value
          let oldRiskObj = this.state.riskList.find(
            (item) => item.riskRegisterId === riskReg.riskRegisterId
          );
          if (oldRiskObj) {
            console.log("oldRiskObj", oldRiskObj);
            riskReg.frequency = oldRiskObj.frequency;
            riskReg["changes"] = oldRiskObj.changes;
          }
          return riskReg;
        });
        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }

        this.setState({ ...this.state, impactMaster: impactMaster });
        await response.riskRegister.map((risk) => {
          if (this.state.expandedRowList.includes(risk.riskRegisterId)) {
            risk["expanded"] = true;
          }
          if (risk.mitigationResps && risk.mitigationResps.length > 0) {
            risk.mitigationResps.map((mit) => {
              let perviousValue = newApprovalIds.filter(
                (item) => mit.riskRegisterActionId === item.id
              );
              if (perviousValue.length > 0) {
                mit["newApproval"] = perviousValue[0].newApproval;
              } else {
                mit["newApproval"] = mit.approved;
              }
              return mit;
            });
          }
          return risk;
        });

        await this.constructImpactApprovalData(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);
        await this.createDynamicDropdowns(response.riskRegister);
        let riskData = response.riskRegister.map((dataItem) => {
          Object.assign(
            {
              selected: this.state.selectedIds.includes(
                dataItem.riskRegisterId
              ),
            },
            dataItem
          );
          return dataItem;
        });
        let sortedData = orderBy(riskData, this.state.sort);
        let data=filterBy(sortedData, this.state.filter);
        this.setState({
          ...this.state,
          riskList: data,
          loader: false,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleCheck(id) {
    return newApprovalIds.some((item) => item === id);
  }
  constructImpactApprovalData = async (riskArray) => {
    riskArray.map((risk) => {
      risk.impactResponse.map((impact) => {
        if (risk.isOpportunity && risk.isOpportunity === "Threat") {
          var totalvalueap = this.countApprovalValue(
            impact.name,
            risk.mitigationResps,
            risk.isOpportunity
          );
          let approvedValue = Math.max(0, impact.value - totalvalueap);

          //new approvel calculation
          var totalvalueNewApp = this.countNewApprovalValue(
            impact.name,
            risk.mitigationResps,
            risk.isOpportunity
          );
          let approvedValueNew = Math.max(0, impact.value - totalvalueNewApp);

          impact["value"] =
            impact.value + "_" + approvedValue + "$" + approvedValueNew;
        } else if (risk.isOpportunity && risk.isOpportunity === "Opportunity") {
          var totalvalue = this.countApprovalValue(
            impact.name,
            risk.mitigationResps,
            risk.isOpportunity
          );
         
          let approvedValue = Math.abs(impact.value) + totalvalue;

          //new approvel calculation
          var totalvalueNew = this.countNewApprovalValue(
            impact.name,
            risk.mitigationResps,
            risk.isOpportunity
          );
          
          let approvedValueNew = Math.abs(impact.value) + totalvalueNew;

          impact["value"] =
            impact.value +
            "_" +
            -Math.abs(approvedValue) +
            "$" +
            -Math.abs(approvedValueNew);
        }
        return impact;
      });

      return risk;
    });
  };

  countApprovalValue = (name, mitigationArray, flag) => {
    var totalvalue = 0;
    mitigationArray.map((mitigation) => {
      if (mitigation.approved) {
        var impactObj = mitigation.impactResponse.filter(
          (item) => item.name === name
        );
        if (impactObj.length > 0) {
          var temp = impactObj[0];
          totalvalue =
            flag === "Threat"
              ? totalvalue + temp.value
              : totalvalue - temp.value;
        }
      }
      return mitigation;
    });
    return totalvalue;
  };
  countNewApprovalValue = (name, mitigationArray, flag) => {
    var totalvalue = 0;
    mitigationArray.map((mitigation) => {
      if (mitigation.newApproval) {
        var impactObj = mitigation.impactResponse.filter(
          (item) => item.name === name
        );
        if (impactObj.length > 0) {
          var temp = impactObj[0];
          totalvalue =
            flag === "Threat"
              ? totalvalue + temp.value
              : totalvalue - temp.value;
        }
      }
      return mitigation;
    });
    return totalvalue;
  };

  createDynamicDropdowns = async (products,filter) => {
    let dropdownColumn = [];
    products.map((res, i) => {
      res.customFields &&
        res.customFields.map((item, j) => {
          if (dropdownColumn.length > 0) {
            if (!dropdownColumn.find((cf) => cf.fieldName === item.fieldName)) {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName,filter),
                inputType: this.getInputType(item.fieldName),
              });
            }
          } else {
            dropdownColumn.push({
              fieldName: item.fieldName,
              data: this.getCustomFieldMasterData(item.fieldName,filter),
              inputType: this.getInputType(item.fieldName),
            });
          }
          return item;
        });

      return res;
    });

    if (dropdownColumn.length > 0) {
      products.map((res) => {
        dropdownColumn.map((col) => {
          let temp = res.customFields.find(
            (item) => item.fieldName === col.fieldName
          );
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              let hashArr = this.stringToHashForCF(val, col.data);
              res[col.fieldName] = hashArr;
            } else if (temp.inputType === "Single Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Free Text") {
              let val = temp.multiText ? temp.multiText : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Numeric") {
              let val = temp.multiText ? parseInt(temp.multiText) : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Date") {
              let val = temp.multiText ? new Date(temp.multiText) : "";
              res[col.fieldName] = val;
            }
          } else {
            res[col.fieldName] = "";
          }
          return col;
        });
        return res;
      });
    }
    let columnsToShow = [];
    if (dropdownColumn.length > 0) {
      columnsToShow = dropdownColumn.map((item) => {
        return (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
            columnMenu={(props) => this.getCustomFieldColumnMenu(props, item)}
            filter={this.getCustomFieldFilter(item)}
            headerClassName={this.checkItsinFilterOrNot(item.fieldName, filter)}
          />
        );
      });
    }
    this.setState({
      ...this.state,
      dropdownColumns: columnsToShow,
      riskList: products,
    });
  };

  getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };

  getcustomfieldfilterlist=(list)=>{
    var sorted_arr =  list.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return sorted_arr
  }

  getsortedrisklist=()=>{
    let sorted_arr =  this.state.riskTypemaster.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  }
  getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      this.getcustomfieldfilterlist(item.data);
      return (
        <CustomFieldSearchMenu
          {...props}
          customFieldsmaster={item.data}
          existingFilter={this.state.existingFilter}
          filterChangeV={this.filterChangeV}
          clearFilter={this.clearFilter}
        />
      );
    }else if(item.inputType === "Single Drop Down"){
      return (                      
        <ColumnMenuCheckboxFilter
          {...props}
          data={this.state.riskList}
          getSelectedColumn={this.getSelectedColumn}
        />
      )
    } else {
      return (
        <ColumnMenuFilter
          {...props}
          getSelectedColumn={this.getSelectedColumn}
        />
      );
    }
  };

  getInputType = (fieldName) => {
    try {
      let arr = this.state.customFieldsmaster.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  getCustomFieldMasterData = (fieldName, filter) => {
    try {
      let arr = this.state.customFieldsmaster.filter(
        (item) => item.fieldName === fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          let checked = this.checkCFinFilterValuesOrNot(
            fieldName,
            item.hashValue,
            filter
          );
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue, //this.convertStrToHash(item),
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
  checkRisktypeSelections = (exfilter) => {
    let temp = [];
    this.state.riskTypemaster.map((item) => {
      let checked = this.checkCFinFilterValuesOrNot(
        "riskTypeNames",
        item.hashValue,
        exfilter
      );
      item["checked"] = checked;
      temp.push(item);
    });
    this.setState({ ...this.state, riskTypemaster: temp });
  };
  checkItsinFilterOrNot = (field, exfilter) => {
    try {
      let headerClassName = "";
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = "active";
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = "active";
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {}
  };
  checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };
  //Impacts

  createDynamicCols = async (products) => {
    let impactColumn = [];
    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name)) {
              impactColumn.push(item.name);
            }
          } else {
            impactColumn.push(item.name);
          }
        });
      }
    });
    
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          let temp = res.impactResponse.filter((item) => item.name === col);
          if (temp.length > 0) {
            res[col] = temp[0].value;
          } else {
            res[col] = undefined;
          }
        });
      });
    }
    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item, index) => (
        <Column
          key={index}
          field={item}
          title={this.getImpactUnit(item)}
          width="180px"
          editable={false}
          cell={(props) => (
            <NumericComponentForScenario
              {...props}
              onEditCell={() => this.numericCellEdit()}
              stateData={products}
            />
          )}
//Its combined values.. so we cant able to filter
          // columnMenu={(props) => (
          //   <ColumnMenuFilter
          //     {...props}
          //     getSelectedColumn={this.getSelectedColumn}
          //   />
          // )}
        />
      ));
    }
    this.setState({ impactColumns: columnsToShow });
  };

  getImpactUnit = (impact) => {
    var impactTemp = this.state.impactMaster.find(
      (item) => item.name === impact
    );
    var res = impact;
    if (impactTemp && impactTemp.name) {
      let unit = impactTemp.units ? impactTemp.units : "";
      res = impactTemp.name + " / " + unit;
    }
    return res;
  };

  numericCellEdit = (dataItem, field, riskData) => {};
  expandChange = (dataItem) => {
    dataItem.expanded = !dataItem.expanded;
    let expandRow = this.state.expandedRowList
      ? this.state.expandedRowList
      : [];
    if (expandRow.includes(dataItem.riskRegisterId)) {
      let expanedState = this.state.expandedRowList;
      let indexValue = expanedState.findIndex(
        (item) => dataItem.riskRegisterId === item
      );
      expanedState.splice(indexValue, 1);
      expandRow = expanedState;
    } else {
      expandRow.push(dataItem.riskRegisterId);
    }
    this.setState({
      expandedRowList: expandRow,
    });
  };
  headerSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.riskList.map((item) => {
      item.selected = checked;
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });

    this.setState({
      ...this.state,
      mitigatedHistogramResponse: {},
      nonMitigatedMonteCarloResponse: {},
      mitigatedTornodoResponse: [],
      nonmitigatedTornodoResponse: [],
      mitigatedTornodoResponseOpportunity: {},
      mitigatedHistogramResponseOpportunity: {},
      nonmitigatedTornodoResponseOpportunity: [],
      nonmitigatedHistogramResponseOpportunity: [],
      nonMitigatedFullTornodoResponses: [],
      mitigatedFullTornodoResponses: [],
      nonMitigatedOppFullTornodoResponses: [],
      mitigatedOppFullTornodoResponses: [],
    });
  };
  saveSelectedIds = (data) => {
    var listOfIds = [];
    for (let row of Object.values(data)) {
      if (row.selected) {
        listOfIds.push(row.riskRegisterId);
      }
    }
    //State is not updated here while clicking check box
    this.state = { selectedIds: listOfIds };
    this.setState({ ...this.state, selectedIds: listOfIds }, () => {
      console.log("selectedIds", this.state.selectedIds);
    });
  };
  createAppState = (dataState) => {
    if (this.state && this.state.riskList) {
      return {
        riskList: this.state.riskList.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        riskList: [],
        dataState: dataState,
      };
    }
  };

  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
  };

  selectionChange = (event) => {
    const data = this.state.riskList.map((item) => {
      if (item.riskRegisterId === event.dataItem.riskRegisterId) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
    this.setState({
      ...this.state,
      mitigatedHistogramResponse: {},
      nonMitigatedMonteCarloResponse: {},
      mitigatedTornodoResponse: [],
      nonmitigatedTornodoResponse: [],
      mitigatedTornodoResponseOpportunity: {},
      mitigatedHistogramResponseOpportunity: {},
      nonmitigatedTornodoResponseOpportunity: [],
      nonmitigatedHistogramResponseOpportunity: [],
      nonMitigatedFullTornodoResponses: [],
      mitigatedFullTornodoResponses: [],
      nonMitigatedOppFullTornodoResponses: [],
      mitigatedOppFullTornodoResponses: [],
    });
  };
  rowClick = (event) => {
    let last = this.lastSelectedIndex;
    const data = [...this.state.riskList];
    const current = data.findIndex((dataItem) => dataItem === event.dataItem);

    if (!event.nativeEvent.shiftKey) {
      this.lastSelectedIndex = last = current;
    }

    if (!event.nativeEvent.ctrlKey) {
      data.forEach((item) => (item.selected = false));
    }
    const select = !event.dataItem.selected;
    for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
      data[i].selected = select;
    }
    this.setState({ data });
  };

  getImpactList = async (id) => {
    try {
      let req = {
        OrgUnitIds: id,
      };
      let response = await Api.getImpactsByWorkstream(req);
      if (response.status === 200 && response.impacts) {
        this.setState({
          ...this.state,
          // loader: false,
          impactslist: response.impacts,
        });
      } else {
        this.setState({ ...this.state, impactslist: [] });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  updateScenario = async () => {
    try {
      var approvalIds = await this.getNewApprovedIds();
      var existingapprriskvalues = await this.getGreenValue();
      var selectedRiskFrequency = await this.getNewFrequencyExistingValue();
      var request = {
        id: this.state.SavedScenarioId,
        existingApprRiskIds: this.state.selectedIds
          ? this.state.selectedIds
          : [],
        Impact: this.state.Impact ? this.state.Impact.name : "",
        Iteration: parseInt(this.state.Iteration),
        existingapprriskvalues: existingapprriskvalues,
        selectedRiskFrequency: selectedRiskFrequency,
        CurrentApprovedValues: approvalIds,
        Name: this.state.Name,
        Description: this.state.Description,
        orgIds: this.state.OrgUnitIds,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.updateScenario(request);
      if (response.status === 200) {
        toastr.success(response.message);
        this.setState({
          ...this.state,
          loader: false,
        });
        this.closeScenarioPopup();
        this.getScenarioList();
      } else {
        toastr.error(response.message);
        this.setState({
          ...this.state,
          loader: false,
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
      });
      console.error(error);
    }
  };
  saveScenaio = async (e) => {
    try {
      var approvalIds = await this.getNewApprovedIds();
      var existingapprriskvalues = await this.getGreenValue();
      var selectedRiskFrequency = await this.getNewFrequencyValue();
      var request = {
        existingApprRiskIds: this.state.selectedIds
          ? this.state.selectedIds
          : [],
        Impact: this.state.Impact ? this.state.Impact.name : "",
        Iteration: parseInt(this.state.Iteration),
        existingapprriskvalues: existingapprriskvalues,
        selectedRiskFrequency: selectedRiskFrequency,
        CurrentApprovedValues: approvalIds,
        Name: this.state.Name,
        Description: this.state.Description,
        orgIds: this.state.OrgUnitIds,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.saveScenario(request);
      if (response.status === 200) {
        toastr.success(response.message);
        this.setState({
          ...this.state,
          loader: false,
        });
        this.closeScenarioPopup();
        this.getScenarioList();
      } else {
        toastr.error(response.message);
        this.setState({
          ...this.state,
          loader: false,
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
      });
      console.error(error);
    }
  };
  getNewApprovedIds = async () => {
    var ids = [];
    try {
      (await this.state.riskList) &&
        this.state.riskList.map((risk) => {
          if (risk.mitigationResps && risk.mitigationResps.length > 0) {
            risk.mitigationResps.map((mit) => {
              if (
                mit.newApproval &&
                this.state.selectedIds.includes(mit.riskRegisterId)
              ) {
                ids.push(mit.riskRegisterActionId);
              }
            });
          }
        });
    } catch (err) {
      console.log(err);
    }

    return ids;
  };

  getGreenValue = async () => {
    var ids = [];
    try {
      await this.state.riskList.map((risk) => {
        if (this.state.selectedIds.includes(risk.riskRegisterId)) {
          if (risk[this.state.Impact.name]) {
            var str = risk[this.state.Impact.name].split("_");
            ids.push(str[1].split("$")[0]);
          } else {
            ids.push("0");
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
    return ids;
  };
  getBlueValue = async () => {
    var ids = [];
    try {
      await this.state.riskList.map((risk) => {
        if (this.state.selectedIds.includes(risk.riskRegisterId)) {
          if (risk[this.state.Impact.name]) {
            var str = risk[this.state.Impact.name];
            ids.push(str.split("$")[1]);
          } else {
            ids.push("0");
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
    return ids;
  };

  getNewFrequencyValue = async () => {
    var ids = [];
    await this.state.riskList.map((risk) => {
      if (this.state.selectedIds.includes(risk.riskRegisterId)) {
        if (risk.frequency) {
          let value =
            risk.changes == "Yes" ? risk.frequency : risk.reductionProbability;
          value = value ? value : 0;
          ids.push(value);
        } else {
          ids.push(0);
        }
      }
    });
    return ids;
  };

  getNewFrequencyExistingValue = async () => {
    var ids = [];
    (await this.state.riskList) &&
      this.state.riskList.map((risk) => {
        if (this.state.selectedIds.includes(risk.riskRegisterId)) {
          var val = risk.frequency.split("$")[1];
          if (val) {
            ids.push(parseFloat(val));
          } else {
            ids.push(0);
          }
        }
      });
    return ids;
  };


  runMonteCarleForExistingData = async (item) => {
    try {
      var existingapprriskvalues = await this.getGreenValue();
      var selectedRiskFrequency = await this.getNewFrequencyExistingValue();
      var CurrentApprovedValues = await this.getBlueValue();
      var request = {
        existingApprRiskIds: this.state.selectedIds
          ? this.state.selectedIds
          : [],
        Impact: this.state.Impact ? this.state.Impact.name : "",
        Iteration: parseInt(this.state.Iteration),
        existingapprriskvalues: existingapprriskvalues,
        selectedRiskFrequency: selectedRiskFrequency,
        CurrentApprovedValues: CurrentApprovedValues,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.runScenarioMontecarlo(request);

      if (response.status === 200) {
        this.setState({
          ...this.state,
          loader: false,
          //Threat
          mitigatedHistogramResponse: response.mitigatedMonteCarloResponse
            ? response.mitigatedMonteCarloResponse.histogramResponse
            : {},
          nonMitigatedMonteCarloResponse:
            response.nonMitigatedMonteCarloResponse
              ? response.nonMitigatedMonteCarloResponse.histogramResponse
              : {},

          mitigatedTornodoResponse: response.mitigatedMonteCarloResponse
            ? response.mitigatedMonteCarloResponse.tornodoResponses
            : [],
          nonmitigatedTornodoResponse: response.nonMitigatedMonteCarloResponse
            ? response.nonMitigatedMonteCarloResponse.tornodoResponses
            : [],
          //oppertunities
          mitigatedTornodoResponseOpportunity:
            response.mitigatedMonteCarloScenarioResponse
              ? response.mitigatedMonteCarloScenarioResponse
                  .tornodoOpportunityResponses
              : {},

          mitigatedHistogramResponseOpportunity:
            response.mitigatedMonteCarloScenarioResponse
              ? response.mitigatedMonteCarloScenarioResponse
                  .histogramOpportunityResponse
              : {},

          nonmitigatedTornodoResponseOpportunity:
            response.nonMitigatedMonteCarloScenarioResponse
              ? response.nonMitigatedMonteCarloScenarioResponse
                  .tornodoOpportunityResponses
              : [],

          nonmitigatedHistogramResponseOpportunity:
            response.nonMitigatedMonteCarloScenarioResponse
              ? response.nonMitigatedMonteCarloScenarioResponse
                  .histogramOpportunityResponse
              : [],

          nonMitigatedFullTornodoResponses:response.mitigatedMonteCarloResponse?
            response.mitigatedMonteCarloResponse
              .nonMitigatedFullTornodoResponses:[],
          mitigatedFullTornodoResponses:response.nonMitigatedMonteCarloResponse?
            response.nonMitigatedMonteCarloResponse
              .mitigatedFullTornodoResponses:[],

          nonMitigatedOppFullTornodoResponses:response.nonMitigatedMonteCarloScenarioResponse?
            response.nonMitigatedMonteCarloScenarioResponse
              .nonMitigatedOppFullTornodoResponses:[],
          mitigatedOppFullTornodoResponses:response.mitigatedMonteCarloScenarioResponse?
            response.mitigatedMonteCarloScenarioResponse
              .mitigatedOppFullTornodoResponses:[],
          openPercentaileModelFlag: false,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
      });

      console.error(error);
    }
  };
  runMonteCarle = async () => {
    try {
      if (parseInt(this.state.Iteration) > 10000) {
        toastr.error(
          "Iteration should be less than 10,000.Because it may be time out"
        );
        return;
      }

      var existingapprriskvalues = await this.getGreenValue();
      var selectedRiskFrequency = await this.getNewFrequencyValue();
      var CurrentApprovedValues = await this.getBlueValue();
      var request = {
        existingApprRiskIds: this.state.selectedIds
          ? this.state.selectedIds
          : [],
        Percentile1: this.state.Percentile1
          ? parseInt(this.state.Percentile1.substring(1))
          : 50,
        Impact: this.state.Impact ? this.state.Impact.name : "",
        Iteration: parseInt(this.state.Iteration),
        existingapprriskvalues: existingapprriskvalues,
        selectedRiskFrequency: selectedRiskFrequency,
        CurrentApprovedValues: CurrentApprovedValues,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.runScenarioMontecarlo(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          loader: false,
          //Threat
          mitigatedHistogramResponse: response.mitigatedMonteCarloResponse
            ? response.mitigatedMonteCarloResponse.histogramResponse
            : {},
          nonMitigatedMonteCarloResponse:
            response.nonMitigatedMonteCarloResponse
              ? response.nonMitigatedMonteCarloResponse.histogramResponse
              : {},

          mitigatedTornodoResponse: response.mitigatedMonteCarloResponse
            ? response.mitigatedMonteCarloResponse.tornodoResponses
            : [],
          nonmitigatedTornodoResponse: response.nonMitigatedMonteCarloResponse
            ? response.nonMitigatedMonteCarloResponse.tornodoResponses
            : [],
          //oppertunities
          mitigatedTornodoResponseOpportunity:
            response.mitigatedMonteCarloScenarioResponse
              ? response.mitigatedMonteCarloScenarioResponse
                  .tornodoOpportunityResponses
              : {},

          mitigatedHistogramResponseOpportunity:
            response.mitigatedMonteCarloScenarioResponse
              ? response.mitigatedMonteCarloScenarioResponse
                  .histogramOpportunityResponse
              : {},

          nonmitigatedTornodoResponseOpportunity:
            response.nonMitigatedMonteCarloScenarioResponse
              ? response.nonMitigatedMonteCarloScenarioResponse
                  .tornodoOpportunityResponses
              : [],

          nonmitigatedHistogramResponseOpportunity:
            response.nonMitigatedMonteCarloScenarioResponse
              ? response.nonMitigatedMonteCarloScenarioResponse
                  .histogramOpportunityResponse
              : [],

          nonMitigatedFullTornodoResponses:response.mitigatedMonteCarloResponse?
            response.mitigatedMonteCarloResponse
              .nonMitigatedFullTornodoResponses:[],
          mitigatedFullTornodoResponses:response.nonMitigatedMonteCarloResponse?
            response.nonMitigatedMonteCarloResponse
              .mitigatedFullTornodoResponses:[],

          nonMitigatedOppFullTornodoResponses:response.nonMitigatedMonteCarloScenarioResponse?
            response.nonMitigatedMonteCarloScenarioResponse
              .nonMitigatedOppFullTornodoResponses:[],
          mitigatedOppFullTornodoResponses:response.mitigatedMonteCarloScenarioResponse?
            response.mitigatedMonteCarloScenarioResponse
              .mitigatedOppFullTornodoResponses:[],
          openPercentaileModelFlag: false,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
      });

      console.error(error);
    }
  };

  runMonteCarleForGrid = async (e) => {
    debugger;
    try {
      var request = {
        riskData: this.state.selectedIds ? this.state.selectedIds : [],
        Impact: this.state.Impact ? this.state.Impact.name : "",
        Percentile: this.state.Percentile
          ? parseInt(this.state.Percentile.substring(1))
          : 0,
        Iteration: parseInt(this.state.Iteration),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.runMonteCarle(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          loader: false,
          impactGridData: response.impactGridData,
          openPercentaileModelFlag: false,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          impactGridData: [],
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
        impactGridData: [],
      });

      console.error(error);
    }
  };
  itemChange = (event) => {
    // if(event.dataItem[event.field]!=event.value){
    event.dataItem[event.field] = event.value;
    event.dataItem["changes"] = "Yes";
    // this.setState({
    //   changes: "Yes_"+event.dataItem.riskRegisterId,
    // });
    // }
  };
  enterEdit = (dataItem, field) => {
    const data =
      this.state.riskList &&
      this.state.riskList.map((item) => ({
        ...item,
        inEdit:
          item.riskRegisterId === dataItem.riskRegisterId ? field : undefined,
      }));
    this.setState({
      riskList: data,
      editField: field,
    });
  };

  exitEdit = () => {
    const data = this.state.riskList.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    this.setState({
      data,
      riskList: data,
      editField: undefined,
    });
  };

  expandCell = (props) => (
    <GridExpandComponent {...props} expandChange={this.expandChange} />
  );
  updateDropdownValue = () => {
    this.exitEdit();
  };
  tempEdit = () => {};
  openDeletePopup = (data) => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: true,
      SavedScenarioId: data.id,
    });
  };
  closeDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: false,
    });
  };

  removeScenario = async () => {
    try {
      const requestParams = {
        DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        id: this.state.SavedScenarioId,
      };

      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteScenario(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeDeletePopup();
        this.getScenarioList();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  onEditCell = () => {};

  sortChange = (event) => {
    this.setState({
      riskList: this.getProducts(event.sort),
      sort: event.sort,
    });
  };
  getProducts = (sort) => {
    return orderBy(this.state.riskList, sort);
  };
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };

  getCustomFieldMasterData = (fieldName) => {
    try {
      let arr = this.state.customFieldsmaster.filter(
        (item) => item.fieldName === fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: false,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
  stringToHash(stringArr, cols) {
    let hashArr = [];

    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      if (cols === "riskTypeNames") {
        valArr &&
          valArr.map((item1) => {
            let risktype = this.state.riskTypemaster.find(
              (item) => item.name === item1
            );
            if (risktype) {
              hashArr.push(risktype.hashValue);
            }
          });
      }
    } else {
      if (stringArr !== "") {
        if (cols === "riskTypeNames") {
          let risktype = this.state.riskTypemaster.find(
            (item) => item.name === stringArr
          );
          if (risktype) {
            hashArr.push(risktype.hashValue);
          }
        }
      }
    }

    return hashArr.toString();
  }
  convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };
  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name === item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name === stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }
  filterChangeExisting =async (e) => {
    if (e.nativeEvent.type === "submit") {
      let existingFilter = this.state.existingFilter
        ? this.state.existingFilter
        : [];
      let filter = e.filter ? e.filter.filters : [];

      // Get the field being filtered from the new filter
      const newFilterFields = new Set();
      if (filter && filter.length > 0) {
        filter.forEach(filterItem => {
          if (filterItem.filters) {
            filterItem.filters.forEach(innerFilter => {
              if (innerFilter.field) {
                newFilterFields.add(innerFilter.field);
              }
            });
          } else if (filterItem.field) {
            newFilterFields.add(filterItem.field);
          }
        });
      }

      // Remove any existing filters for the same fields
      let filteredExisting = existingFilter.filter(item => {
        // For filters with nested filters array
        if (item.filters) {
          return !item.filters.some(innerFilter =>
            innerFilter.field && newFilterFields.has(innerFilter.field)
          );
        }
        // For direct filters
        return !(item.field && newFilterFields.has(item.field));
      });

      // Combine filtered existing filters with new filters
      let combinedFilters = [...filteredExisting, ...filter];

      // Deduplicate the combined filters
      const uniqueFilters = new Set();
      const dedupedFilters = [];

      for (const filterItem of combinedFilters) {
        const filterStr = JSON.stringify(filterItem);
        if (!uniqueFilters.has(filterStr)) {
          uniqueFilters.add(filterStr);
          dedupedFilters.push(filterItem);
        }
      }
      existingFilter = dedupedFilters;
      const result = filterBy(this.state.riskTemp, dedupedFilters);
      if (result && result.length > 0) {
      await this.createDynamicDropdowns(result, dedupedFilters);
      await this.checkRisktypeSelections(dedupedFilters);
      }
      var riskData = result.map((dataItem) =>
        Object.assign({ selected: true }, dataItem)
      );
      this.setState({
        ...this.state,
        riskList: riskData,
        existingFilter: dedupedFilters,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        filter: e.filter,
      });
      this.saveSelectedIds(riskData);
    } else if (e.nativeEvent.type === "reset") {
      let exi = [];
      if (this.state.existingFilter) {
        let filterData = this.state.existingFilter;
        filterData.forEach((filter2) => {
          if (filter2.filters) {
             // Only add the filter if none of its inner filters match the selected column
            const hasMatchingInnerFilter = filter2.filters.some(
              innerFilter => innerFilter.field === this.state.selectedColumn
            );
            if (!hasMatchingInnerFilter) {
              exi.push(filter2);
            }
          } else {
            if (filter2.field !== this.state.selectedColumn) {
              exi.push(filter2);
            }
          }
        });
      }
      const result = filterBy(this.state.riskTemp, exi);
      await this.createDynamicDropdowns(result, exi);
      await this.checkRisktypeSelections(exi);
      var riskData = result.map((dataItem) =>
        Object.assign({ selected: true }, dataItem)
      );
      this.setState(
        {
          ...this.state,
          riskList: riskData,
          existingFilter: exi,
          take: Math.round((window.innerHeight - 250) / 35),
          skip: 0,
          filter: e.filter,
        },
        console.log(result.length)
      );
      this.saveSelectedIds(riskData);
    }
  };
  getSelectedColumn = (col) => {
    if (col !== this.state.selectedColumn) {
      this.setState({ ...this.state, selectedColumn: col });
    }
  };

  filterChangeV =async (e, colname) => {
    let exi = [];
    if (this.state.existingFilter) {
      let filterData = this.state.existingFilter;
      filterData.map((filter2) => {
        if (filter2.filters) {
          filter2.filters.map((innerFilter) => {
            if (innerFilter.field !== colname) {
              exi.push(filter2);
            }
          });
        } else {
          if (filter2.field !== colname) {
            exi.push(filter2);
          }
        }
      });
    }

    let filter = e ? e.filters : [];
    let temp = [];
    if (filter.length > 0) {
      temp = [
        {
          filters: filter,
          logic: "or",
        },
      ];
    }

    let arr = [...exi, ...temp];

    const result = filterBy(this.state.riskTemp, arr);
    if (result && result.length > 0) {
    await this.createDynamicDropdowns(result, arr);
      await this.checkRisktypeSelections(arr);
    }
    var riskData = result.map((dataItem) =>
      Object.assign({ selected: true }, dataItem)
    );
    this.setState({
      ...this.state,
      riskList: riskData,
      existingFilter: arr,
      take: Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      filter: {
        logic: "and",
        filters: arr,
      },
    });
    this.saveSelectedIds(riskData);
  };
  clearFilter = (e) => {
    let filter = e ? e : [];
    const result = filterBy(this.state.riskTemp, filter);
     this.createDynamicDropdowns(result, filter);
       this.checkRisktypeSelections(filter);
    var riskData = result.map((dataItem) =>
      Object.assign({ selected: true }, dataItem)
    );
    this.setState({
      ...this.state,
      riskList: riskData,
      existingFilter: filter,
      take: Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      filter: {
        logic: "and",
        filters: filter,
      },
    });
    this.saveSelectedIds(riskData);
  };
  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue&&originalValue.name!=" [blank]") {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };
  viewMultiselectColsRiskType = (event) => {
    let value = event.dataItem[event.field];
    let temp = [];

    if (value && value.includes(",")) {
      let arr = value.split(",");
      arr &&
        arr.map((item1, i) => {
          let originalValue = this.state.riskTypemaster.find(
            (item) => item.hashValue === item1
          );
          if (originalValue) {
            temp.push(originalValue.name);
          }
        });
    } else {
      let originalValue = this.state.riskTypemaster.find(
        (item) => item.hashValue === value
      );
      if (originalValue&&originalValue.name!=" [blank]") {
        temp.push(originalValue.name);
      }
    }
    return <td title={temp.toString()}>{temp.toString()}</td>;
  };

  selectViewAction = async (data) => {
    let primeHideFlag = secureLocalStorage.getItem("isPrime")==true?true:false;
    mapTree(this.state.data, "children", (item) => {
      if (this.state.OrgUnitIds.includes(item.unitId)) {
        if (!item.isPrime) {
          primeHideFlag = item.isPrime;
        }
      }
      return item;
    });
    await this.getRiskDataByViewId(data.id);
    this.setState({
      ...this.state,
      viewId: data.id,
      primeHideFlag:primeHideFlag,
      mitigatedHistogramResponse: {},
          nonMitigatedMonteCarloResponse: {},
          mitigatedTornodoResponse: [],
          nonmitigatedTornodoResponse: [],
          mitigatedTornodoResponseOpportunity: {},
          mitigatedHistogramResponseOpportunity: {},
          nonmitigatedTornodoResponseOpportunity: [],
          nonmitigatedHistogramResponseOpportunity: [],
          nonMitigatedFullTornodoResponses: [],
          mitigatedFullTornodoResponses: [],
          nonMitigatedOppFullTornodoResponses: [],
          mitigatedOppFullTornodoResponses: [],
    });
  };
  getRiskDataByViewId = async (id) => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      const requestParams = {
        ViewId: id,
        CreatedBy: parseInt(createdby),
      };
      this.setState({
        ...this.state,
        loader: true,
        viewType: "RISK",
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        existingFilter: [],
        filter: {
          logic: "and",
          filters: [],
        }
      });
      let result = await Api.getByViewId(requestParams);
      if (result.status === 200) {

        if(result.isCustomFieldDeleted||result.isImpactDeleted||result.notValidPrimeDataset){
          
          this.setState({
            ...this.state,
            riskList: [],
            selectedOrgUnit: [],
            riskTemp: [],
            loader: false,
            isCustomFieldDeleted:result.isCustomFieldDeleted,
            isImpactDeleted:result.isImpactDeleted,
            notValidPrimeDataset:result.notValidPrimeDataset,
          });
          return;
        }
        let response = result;
        var selectedOrgUnitArray = [];
        response.riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.createdDate) {
            riskReg.createdDate = new Date(riskReg.createdDate);
          }
          
          selectedOrgUnitArray.push(riskReg.organizationUnitId);

          if (riskReg.riskTypeNames) {
            let hashArr = this.stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );

            riskReg["riskTypeNames"] = hashArr;
          }else{
            riskReg["riskTypeNames"] = "undefined";
            riskReg["riskTypeNamesExport"]="";
          }
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Close";
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
        });
        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }
        this.setState({ ...this.state, impactMaster: impactMaster });
        await this.constructImpactApprovalData(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);
        await this.createDynamicDropdowns(response.riskRegister);

        this.setState({
          ...this.state,
          selectedOrgUnit: selectedOrgUnitArray,
          OrgUnitIds: Array.from(new Set(selectedOrgUnitArray)),
          riskTemp: response.riskRegister,
          loader: false,
        });
        var riskData = response.riskRegister.map((dataItem) =>
          Object.assign({ selected: true }, dataItem)
        );
        this.setState({
          ...this.state,
          riskList: riskData,
          riskTemp: riskData,
          loader: false,
          mitigatedHistogramResponse: {},
          nonMitigatedMonteCarloResponse: {},
          mitigatedTornodoResponse: [],
          nonmitigatedTornodoResponse: [],
          mitigatedTornodoResponseOpportunity: {},
          mitigatedHistogramResponseOpportunity: {},
          nonmitigatedTornodoResponseOpportunity: [],
          nonmitigatedHistogramResponseOpportunity: [],
        });
        this.refs.child.refreshData(Array.from(new Set(selectedOrgUnitArray)));
        this.saveSelectedIds(riskData);
        this.getImpactList(Array.from(new Set(selectedOrgUnitArray)));
      } else {
        this.refs.child.refreshData([]);

        this.setState({
          ...this.state,
          riskList: [],
          selectedOrgUnit: [],
          riskTemp: [],
          loader: false,
        });
      }
    } catch (error) {
      console.log(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  refreshPage = () => {
    window.location.reload();
  };
  setClassName = (field) => {
    let headerClassName = "";
    if (this.state.filter && this.state.filter.filters) {
      this.state.filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };
  render() {
    let isPrime=this.state.primeHideFlag;

    return (
      <div className="scenarioContainer">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <div className="riskViewCont">
          <div className="rvRow">
            <div className="sidebar">
              <a
                href="#"
                class="sidebarNavIcon"
                onClick={() => this.openSidebar(this.state.openSiderBar)}
              >
                <img src={Images.SETTINGS} width="18" alt="Stream" />
              </a>
              <div
                ref={(node) => {
                  this.node = node;
                }}
                className={
                  this.state.openSiderBar === true ? "gbox show" : "gbox"
                }
              >
                <div className="header">
                  Workstream
                  <a
                    href="#"
                    title="Reset page"
                    className="refreshDataset"
                    onClick={this.refreshPage}
                  >
                    <img src={Images.REFRESH} width="10" alt="" />
                  </a>
                </div>
                <div className="treeView">
                  <OrganizationTreeList
                    {...this.props}
                    orgUnitData={this.state.data}
                    getRiskList={this.getRiskList}
                    getEmptyRiskList={this.setEmptyRiskList}
                    ref="child"
                  />
                  <div>
                    <div className="selectscenario">
                      <p>Select Scenario</p>

                      <div className="iconCont1">
                        <a
                          href="#"
                          onClick={() => this.TogglescenarioDataset()}
                          className={
                            this.state.showscenario
                              ? "openedarrowIcon"
                              : "arrowIcon"
                          }
                        >
                          <img src={Images.ARROW} width="10" alt="" />
                        </a>
                      </div>
                    </div>
                    {this.state.showscenario ? (
                      <div className="scenarioList">
                        <ul>
                          {this.state.scenarioList &&
                            this.state.scenarioList.map((item) => {
                              return (
                                <li
                                  className={
                                    item.id === this.state.activeLink
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <a
                                    // href="#"
                                    style={{ paddingLeft: "8px" }}
                                    title={item.description}
                                    onClick={() => this.selectScenario(item)}
                                  >
                                    {item.name}
                                  </a>
                                  <a
                                    href="#"
                                    title="Delete scenario"
                                    className="iconR"
                                    onClick={() => this.openDeletePopup(item)}
                                  >
                                    <img src={Images.TRASH} width="12" alt="" />
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="gBoxSelection autoHeight">
                    <div className="qdReports">
                      <div className="secHeader pointer d-flex">
                        <h5>Select Risk Dataset</h5>
                        <div className="iconCont">
                          <a
                            href="#"
                            onClick={() => this.ToggleRiskDataset()}
                            className={
                              this.state.showRiskDataSet
                                ? "opened arrowIcon"
                                : "arrowIcon"
                            }
                          >
                            <img src={Images.ARROW} width="10" alt="" />
                          </a>
                        </div>
                      </div>
                      {this.state.showRiskDataSet ? (
                        <div className="viewConts analListViewCont">
                          <div className="listView">
                            <ul>
                              {this.state.riskDatasetList &&
                                this.state.riskDatasetList.map(
                                  (data, index) => {
                                    return (
                                      <li
                                        className={
                                          data.id === this.state.viewId
                                            ? "active"
                                            : ""
                                        }
                                      >
                                        <div class="dbLists"  onClick={() =>
                                              this.selectViewAction(data)
                                            }>
                                          <span className="statusIcon">
                                            <img
                                              src={
                                                data.scope === 0
                                                  ? Images.LOCK
                                                  : Images.UNLOCK
                                              }
                                              className="stateIcon"
                                              width="20"
                                              alt=""
                                            />
                                          </span>
                                          <h5
                                            onClick={() =>
                                              this.selectViewAction(data)
                                            }
                                          >
                                            <h5
                                              title={
                                                data.description
                                                  ? data.description
                                                  : "Description not available"
                                              }
                                            >
                                              {data.name}
                                            </h5>
                                          </h5>
                                        </div>
                                      </li>
                                    );
                                  }
                                )}
                            </ul>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="riskConts">
              <div className="gBox" id="rw-tab-header">
                <div className="regCont">
                  <h5>Risks</h5>
                  <div className="tblCont riskRegister dataGrids AnalyticsRisks" id="AnalyticsRisks">
                    <Grid
                      style={{ minHeight: "100px" }}
                      data={filterBy(
                        this.state.riskList ? this.state.riskList : [],
                        this.state.filter
                      ).slice(
                        this.state.skip,
                        this.state.take + this.state.skip
                      )}
                      reorderable
                      resizable
                      expandField="expanded"
                      detail={(props) => (
                        <MitigationExpandForScenaio
                          {...props}
                          refreshRiskList={this.refreshRiskList}
                        />
                      )}
                      {...this.state.dataState}
                      onDataStateChange={this.dataStateChange}
                      pageable={true}
                      onItemChange={this.itemChange}
                      cellRender={this.renderers.cellRender}
                      rowRender={this.renderers.rowRender}
                      editField="inEdit"
                      sortable={{
                        allowUnsort: true,
                        mode: "multiple",
                      }}
                      sort={this.state.sort}
                      onSortChange={this.sortChange}
                      total={
                        filterBy(this.state.riskList, this.state.filter).length
                      }
                      skip={this.state.skip}
                      take={this.state.take}
                      onPageChange={this.pageChange}
                      onFilterChange={this.filterChangeExisting}
                      filter={this.state.filter}
                    >
                      <GridNoRecords>
                        {this.state.notValidPrimeDataset
                          ? "Cannot load dataset as Prime settings have been changed for Tenant or Workstream"
                          : this.state.isCustomFieldDeleted
                          ? "Associated Dataset's Custom fields might been deleted or revoked"
                          : this.state.isImpactDeleted
                          ? "Associated Dataset's Impact fields might been deleted or revoked"
                          : "No records available"}
                      </GridNoRecords>

                      {/* <Column
                        field="selected"
                        width="42px"
                        headerSelectionValue={
                            this.state.riskList.findIndex(dataItem => dataItem.selected === false) === -1
                        } /> */}
                      <Column cell={this.expandCell} width="40px" title="" />
                      <Column
                        locked={true}
                        field="organizationUnitName"
                        title="Workstream"
                        width="100px"
                        editable={false}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName(
                          "organizationUnitName"
                        )}
                      />
                      

                      <Column
                        locked={true}
                        field="riskTitle"
                        title="Risk Title"
                        width="150px"
                        editable={false}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("riskTitle")}
                      />
                      <Column
                        field="name"
                        title="Risk Description"
                        width="80px"
                        cell={(props) => (
                          <RiskDescriptionCell
                            {...props}
                            onEditCell={this.tempEdit}
                            updateDropdownValue={this.updateDropdownValue}
                          />
                        )}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        editable={false}
                        headerClassName={this.setClassName("name")}
                      />
                      <Column
                        field="isOpportunity"
                        title="T/O"
                        width="150px"
                        editable={false}
                        columnMenu={(props) => (
                          <ColumnMenuCheckboxFilter
                            {...props}
                            data={this.state.riskList}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        cell={(props) =>
                          props.dataItem.isOpportunity === "Threat" ? (
                            <td>{props.dataItem.isOpportunity}</td>
                          ) : (
                            <td><span className="turquoiseBlue">{props.dataItem.isOpportunity}</span></td>

                          )
                        }
                        headerClassName={this.setClassName("isOpportunity")}
                      />
                      <Column
                        field="number"
                        title="Risk Number"
                        width="100px"
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        editable={false}
                        headerClassName={this.setClassName("number")}
                      />
{this.getsortedrisklist()}
                      <Column
                        field="riskTypeNames"
                        title="Risk Type"
                        width="150px"
                        cell={this.viewMultiselectColsRiskType}
                        columnMenu={(props) => (
                          <SearchMenu
                            {...props}
                            existingFilter={this.state.existingFilter}
                            data={this.state.riskTypemaster}
                            filterChangeV={this.filterChangeV}
                            clearFilter={this.clearFilter}
                          />
                        )}
                        headerClassName={this.setClassName("riskTypeNames")}
                      />

                      {this.state.dropdownColumns}
                      <Column
                        field="cause"
                        title="Cause"
                        width="100px"
                        editable={false}
                        cell={(props) => (
                          <RiskCauseCell
                            {...props}
                            onEditCell={this.tempEdit}
                            updateDropdownValue={this.updateDropdownValue}
                          />
                        )}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("cause")}
                      />
                      <Column
                        field="existingControl"
                        title="Existing Control"
                        width="100px"
                        editable={false}
                        cell={(props) => (
                          <ExistingControlCell
                            {...props}
                            onEditCell={this.tempEdit}
                            updateDropdownValue={this.updateDropdownValue}
                          />
                        )}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("existingControl")}
                      />
                      <Column
                        field="frequency"
                        title="Probability (%)"
                        width="150px"
                        editable={true}
                        filter={"numeric"}
                        cell={(props) => (
                          <FrequencyComponentFoScenario
                            {...props}
                            onEditCell={this.enterEdit}
                            riskData={this.state.riskTemp}
                            riskList={this.state.riskList}
                            updateDropdownValue={this.updateDropdownValue}
                            // changes={this.state.changes}
                          />
                        )}
                        // columnMenu={(props) => (
                        //   <ColumnMenuFilter
                        //     {...props}
                        //     getSelectedColumn={this.getSelectedColumn}
                        //   />
                        // )}
                        // headerClassName={this.setClassName("frequency")}
                      />
                      {/* <Column
                          field="reductionProbability"
                          title="Reduction Probability"
                          width="75px"
                          editable={false}
                          cell={(props) => (
                            <td className='yellowCell'>{props.dataItem.reductionProbability}</td> 
                          )}
                          filter={"numeric"}
                          columnMenu={(props) => (
                            <ColumnMenuFilter
                              {...props}
                              getSelectedColumn={this.getSelectedColumn}
                            />
                          )}
                        /> */}
                      <Column
                        field="pre"
                        title="pre"
                        width="75px"
                        sortable={false}
                        editable={false}
                        cell={(props) => (
                          <PrePostComponenant
                            {...props}
                            HeatMapConfigDataOpportunity={this.state.HeatMapConfigDataOpportunity}
                          HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
                          dynamicHeatmapProbabilityRange={this.state.dynamicHeatmapProbabilityRange}
                          />
                        )}
                      />
                      <Column
                        field="current"
                        title="current"
                        width="75px"
                        sortable={false}
                        editable={false}
                        cell={(props) => (
                          <PrePostComponenant
                            {...props}
                            HeatMapConfigDataOpportunity={this.state.HeatMapConfigDataOpportunity}
                          HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
                          dynamicHeatmapProbabilityRange={this.state.dynamicHeatmapProbabilityRange}
                          />
                        )}
                      />
                      <Column
                        field="post"
                        title="post"
                        width="75px"
                        editable={false}
                        sortable={false}
                        cell={(props) => (
                          <PrePostComponenant
                            {...props}
                            HeatMapConfigDataOpportunity={this.state.HeatMapConfigDataOpportunity}
                          HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
                          dynamicHeatmapProbabilityRange={this.state.dynamicHeatmapProbabilityRange}
                          />
                        )}
                      />
                      {/* <Column
                        field="overAll"
                        title="OverAll Impact"
                        width="100px"
                        editable={false}
                        sortable={false}
                        cell={(props) => <OverallComponenant {...props} />}
                      /> */}
                      {/* New  */}

                      <Column
                        field="preRiskScore"
                        title="Risk Score (Pre)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        headerClassName={this.setClassName("preRiskScore")}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                      />

                      {isPrime && (
                        <Column
                          field="preWeightedRiskScore"
                          title="Prime Risk Score (Pre)"
                          filter={"numeric"}
                          width="80px"
                          editable={false}
                          headerClassName={this.setClassName(
                            "preWeightedRiskScore"
                          )}
                          columnMenu={(props) => (
                            <ColumnMenuFilter
                              {...props}
                              getSelectedColumn={this.getSelectedColumn}
                            />
                          )}
                          cell={(props) => (
                            <td>
                              <span>
                                {props.dataItem.isPrimeWorkstreams &&
                                secureLocalStorage.getItem("isPrime") == true
                                  ? props.dataItem.preWeightedRiskScore
                                  : ""}
                              </span>
                            </td>
                          )}
                        />
                      )}

                      <Column
                        field="currentRiskScore"
                        title="Risk Score (Current)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        headerClassName={this.setClassName("currentRiskScore")}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        cell={(props) => (
                          <td>
                            <span className="turquoiseBlue">
                              {props.dataItem.currentRiskScore}
                            </span>
                          </td>
                        )}
                      />

                      {isPrime && (
                        <Column
                          field="currentWeightedRiskScore"
                          title="Prime Risk Score (Current)"
                          filter={"numeric"}
                          width="80px"
                          editable={false}
                          headerClassName={this.setClassName(
                            "currentWeightedRiskScore"
                          )}
                          columnMenu={(props) => (
                            <ColumnMenuFilter
                              {...props}
                              getSelectedColumn={this.getSelectedColumn}
                            />
                          )}
                          cell={(props) => (
                            <td>
                              <span className="turquoiseBlue">
                                {props.dataItem.isPrimeWorkstreams &&
                                secureLocalStorage.getItem("isPrime") == true
                                  ? props.dataItem.currentWeightedRiskScore
                                  : ""}
                              </span>
                            </td>
                          )}
                        />
                      )}

                      <Column
                        field="postRiskScore"
                        title="Risk Score (Post)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        headerClassName={this.setClassName("postRiskScore")}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        cell={(props) => (
                          <td>
                            <span className="yellowCell">
                              {props.dataItem.postRiskScore}
                            </span>
                          </td>
                        )}
                      />

                      {isPrime && (
                        <Column
                          field="postWeightedRiskScore"
                          title="Prime Risk Score (Post)"
                          filter={"numeric"}
                          width="80px"
                          editable={false}
                          headerClassName={this.setClassName(
                            "postWeightedRiskScore"
                          )}
                          columnMenu={(props) => (
                            <ColumnMenuFilter
                              {...props}
                              getSelectedColumn={this.getSelectedColumn}
                            />
                          )}
                          cell={(props) => (
                            <td>
                              <span className="yellowCell">
                                {props.dataItem.isPrimeWorkstreams &&
                                secureLocalStorage.getItem("isPrime") == true
                                  ? props.dataItem.postWeightedRiskScore
                                  : ""}
                              </span>
                            </td>
                          )}
                        />
                      )}
                      {/* End  */}
                      {this.state.impactColumns}
                      <Column
                        field="impactComments"
                        title="Consequences"
                        width="120px"
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("impactComments")}
                      />
                      <Column
                        field="proximityDate"
                        title="Proximity Date"
                        width="120px"
                        editor="date"
                        filter={"date"}
                        format="{0:dd-MMM-yyyy}"
                        editable={false}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("proximityDate")}
                      />
                      <Column
                        field="createdDate"
                        title="created Date"
                        filter={"date"}
                        format="{0:dd-MMM-yyyy}"
                        width="150px"
                        editable={false}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("createdDate")}
                      />
                       <Column
                        field="createdByName"
                        title="created By"
                        width="150px"
                        editable={false}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("createdByName")}
                      />
                      <Column
                        field="isClosed"
                        title="Status"
                        width="80px"
                        editor="boolean"
                        cell={(props) => (
                          <StatusComponent
                            {...props}
                            onEditCell={this.onEditCell}
                          />
                        )}
                        
                        editable={false}
                        
                        columnMenu={(props) => (
                          <ColumnMenuCheckboxFilter
                            {...props}
                            data={this.state.riskList}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("isClosed")}
                      />
                      
                      <Column
                      field="closedDate"
                      title="closed Date"
                      width="120px"
                      editor="date"
                      filter={"date"}
                      editable={false}
                      format="{0:dd-MMM-yyyy}"
                      columnMenu={(props) => (
                        <ColumnMenuFilter
                          {...props}
                          getSelectedColumn={this.getSelectedColumn}
                        />
                      )}
                      headerClassName={this.setClassName("closedDate")}
                    />
                    </Grid>
                  </div>
                </div>
              </div>

              <div className="gBox" id="rw-tab-header">
                <div className="regCont">
                  <div className="header">
                    <h5>Aggregration</h5>
                    <ul>
                      <li>
                        <small>Select Impact</small>
                        <DropDownList
                          data={this.state.impactslist}
                          value={this.state.Impact}
                          valueField="impactId"
                          textField="name"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              Impact: e.target.value,
                            });
                          }}
                        />
                      </li>
                      <li className="smallField">
                        <small>Percentile</small>
                        <DropDownList
                          data={this.Percentile}
                          value={this.state.Percentile}
                          defaultValue={"P50"}
                          width="100px"
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              Percentile1: e.target.value,
                            })
                          }
                        />
                      </li>
                      <li className="smallField">
                        <small>No. of Iterations</small>
                        <DropDownList
                          data={this.Iteration}
                          value={this.state.Iteration}
                          defaultValue={this.state.Iteration}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              Iteration: e.target.value,
                            });
                          }}
                        />
                      </li>
                      <li onClick={this.runMonteCarle}>
                        <button
                          disabled={!this.state.Impact || !this.state.Iteration}
                        >
                          Run Monte Carlo
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="tblCont riskRegister dataGrids " id= "dataGrids_riskRegister">
                    <Grid
                      style={{ minHeight: "100px" }}
                      data={filterBy(
                        this.state.riskList,
                        this.state.filter
                      ).slice(
                        this.state.skip,
                        this.state.take + this.state.skip
                      )}
                      reorderable
                      resizable
                      {...this.state.dataState}
                      onDataStateChange={this.dataStateChange}
                      selectedField="selected"
                      onSelectionChange={this.selectionChange}
                      onHeaderSelectionChange={this.headerSelectionChange}
                      pageable={true}
                      sortable={{
                        allowUnsort: true,
                        mode: "multiple",
                      }}
                      sort={this.state.sort}
                      onSortChange={this.sortChange}
                      total={
                        filterBy(this.state.riskList, this.state.filter).length
                      }
                      skip={this.state.skip}
                      take={this.state.take}
                      onPageChange={this.pageChange}
                      onFilterChange={this.filterChangeExisting}
                      filter={this.state.filter}
                    >
                      <GridNoRecords>
                        {this.state.notValidPrimeDataset
                          ? "Cannot load dataset as Prime settings have been changed for Tenant or Workstream"
                          : this.state.isCustomFieldDeleted
                          ? "Associated Dataset's Custom fields might been deleted or revoked"
                          : this.state.isImpactDeleted
                          ? "Associated Dataset's Impact fields might been deleted or revoked"
                          : "No records available"}
                      </GridNoRecords>

                      <Column
                        field="selected"
                        locked={true}
                        width="42px"
                        headerSelectionValue={
                          this.state.riskList.findIndex(
                            (dataItem) => dataItem.selected === false
                          ) === -1
                        }
                      />
                      <Column
                        field="organizationUnitName"
                        title="Workstream"
                        width="100px"
                        locked={true}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName(
                          "organizationUnitName"
                        )}
                      />
                      
                      <Column
                        locked={true}
                        field="riskTitle"
                        title="Risk Title*"
                        width="150px"
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("riskTitle")}
                      />
                      <Column
                        field="name"
                        title="Risk Description"
                        width="80px"
                        editable={false}
                        cell={(props) => <RiskDescriptionCell {...props} />}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("name")}
                      />
                      <Column
                        field="isOpportunity"
                        title="T/O"
                        width="150px"
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        cell={(props) =>
                          props.dataItem.isOpportunity === "Threat" ? (
                            <td>{props.dataItem.isOpportunity}</td>
                          ) : (
                            <td><span className="turquoiseBlue">{props.dataItem.isOpportunity}</span></td>
                          )
                        }
                        headerClassName={this.setClassName("isOpportunity")}
                      />
                      <Column
                        field="number"
                        title="Risk Number"
                        width="100px"
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("number")}
                      />

                      <Column
                        field="riskTypeNames"
                        title="Risk Type"
                        width="150px"
                        cell={this.viewMultiselectColsRiskType}
                        columnMenu={(props) => (
                          <SearchMenu
                            {...props}
                            existingFilter={this.state.existingFilter}
                            data={this.state.riskTypemaster}
                            filterChangeV={this.filterChangeV}
                            clearFilter={this.clearFilter}
                          />
                        )}
                        headerClassName={this.setClassName("riskTypeNames")}
                      />

                      {this.state.dropdownColumns}
                      <Column
                        field="cause"
                        title="Cause"
                        width="100px"
                        editable={false}
                        cell={(props) => <RiskCauseCell {...props} />}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("cause")}
                      />
                      <Column
                        field="existingControl"
                        title="Existing Control"
                        width="100px"
                        editable={false}
                        cell={(props) => <ExistingControlCell {...props} />}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("existingControl")}
                      />
                      <Column
                        field="frequency"
                        title="Probability (%)"
                        width="150px"
                        filter={"numeric"}
                        editable={false}
                        cell={(props) => (
                          <FrequencyComponentFoScenario
                            {...props}
                            onEditCell={this.exitEdit}
                            riskData={this.state.riskTemp}
                            riskList={this.state.riskList}
                            updateDropdownValue={this.updateDropdownValue}
                            // changes={this.state.changes}
                          />
                        )}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("frequency")}
                      />
                      {/* New  */}

                      <Column
                        field="preRiskScore"
                        title="Risk Score (Pre)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        headerClassName={this.setClassName("preRiskScore")}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                      />

                      {isPrime && (
                        <Column
                          field="preWeightedRiskScore"
                          title="Prime Risk Score (Pre)"
                          filter={"numeric"}
                          width="80px"
                          editable={false}
                          headerClassName={this.setClassName(
                            "preWeightedRiskScore"
                          )}
                          columnMenu={(props) => (
                            <ColumnMenuFilter
                              {...props}
                              getSelectedColumn={this.getSelectedColumn}
                            />
                          )}
                          cell={(props) => (
                            <td>
                              <span>
                                {props.dataItem.isPrimeWorkstreams &&
                                secureLocalStorage.getItem("isPrime") == true
                                  ? props.dataItem.preWeightedRiskScore
                                  : ""}
                              </span>
                            </td>
                          )}
                        />
                      )}

                      <Column
                        field="currentRiskScore"
                        title="Risk Score (Current)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        headerClassName={this.setClassName("currentRiskScore")}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        cell={(props) => (
                          <td>
                            <span className="turquoiseBlue">
                              {props.dataItem.currentRiskScore}
                            </span>
                          </td>
                        )}
                      />

                      {isPrime && (
                        <Column
                          field="currentWeightedRiskScore"
                          title="Prime Risk Score (Current)"
                          filter={"numeric"}
                          width="80px"
                          editable={false}
                          headerClassName={this.setClassName(
                            "currentWeightedRiskScore"
                          )}
                          columnMenu={(props) => (
                            <ColumnMenuFilter
                              {...props}
                              getSelectedColumn={this.getSelectedColumn}
                            />
                          )}
                          cell={(props) => (
                            <td>
                              <span className="turquoiseBlue">
                                {props.dataItem.isPrimeWorkstreams &&
                                secureLocalStorage.getItem("isPrime") == true
                                  ? props.dataItem.currentWeightedRiskScore
                                  : ""}
                              </span>
                            </td>
                          )}
                        />
                      )}

                      <Column
                        field="postRiskScore"
                        title="Risk Score (Post)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        headerClassName={this.setClassName("postRiskScore")}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        cell={(props) => (
                          <td>
                            <span className="yellowCell">
                              {props.dataItem.postRiskScore}
                            </span>
                          </td>
                        )}
                      />

                      {isPrime && (
                        <Column
                          field="postWeightedRiskScore"
                          title="Prime Risk Score (Post)"
                          filter={"numeric"}
                          width="80px"
                          editable={false}
                          headerClassName={this.setClassName(
                            "postWeightedRiskScore"
                          )}
                          columnMenu={(props) => (
                            <ColumnMenuFilter
                              {...props}
                              getSelectedColumn={this.getSelectedColumn}
                            />
                          )}
                          cell={(props) => (
                            <td>
                              <span className="yellowCell">
                                {props.dataItem.isPrimeWorkstreams &&
                                secureLocalStorage.getItem("isPrime") == true
                                  ? props.dataItem.postWeightedRiskScore
                                  : ""}
                              </span>
                            </td>
                          )}
                        />
                      )}
                      {/* End  */}
                      {this.state.impactColumns}
                      <Column
                        field="impactComments"
                        title="Consequences"
                        width="120px"
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("impactComments")}
                      />
                      <Column
                        field="proximityDate"
                        title="Proximity Date"
                        width="120px"
                        editor="date"
                        filter={"date"}
                        format="{0:dd-MMM-yyyy}"
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("proximityDate")}
                      />
                      <Column
                        field="createdDate"
                        title="created Date"
                        filter={"date"}
                        format="{0:dd-MMM-yyyy}"
                        width="150px"
                        editable={false}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("createdDate")}
                      />
                       <Column
                        field="createdByName"
                        title="created By"
                        width="150px"
                        editable={false}
                        columnMenu={(props) => (
                          <ColumnMenuFilter
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("createdByName")}
                      />
                      <Column
                        field="isClosed"
                        title="Status"
                        width="80px"
                        editor="boolean"
                        cell={(props) => (
                          <StatusComponent
                            {...props}
                            onEditCell={this.onEditCell}
                          />
                        )}
                        filter={"boolean"}
                        
                        columnMenu={(props) => (
                          <ColumnMenuCheckboxFilter
                            {...props}
                            data={this.state.riskList}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("isClosed")}
                      />
                      
                      <Column
                      field="closedDate"
                      title="closed Date"
                      width="120px"
                      editor="date"
                      filter={"date"}
                      editable={false}
                      format="{0:dd-MMM-yyyy}"
                      columnMenu={(props) => (
                        <ColumnMenuFilter
                          {...props}
                          getSelectedColumn={this.getSelectedColumn}
                        />
                      )}
                      headerClassName={this.setClassName("closedDate")}
                    />
                    </Grid>
                  </div>
                </div>
              </div>

              <div className="wBox">
                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>Post-Mitigated - Threat</b>
                      </h4>
                    </div>
                    <div className="chartCont">
                      <HistogramChart
                        {...this.props}
                        isOpportunity={false}
                        histogramResponse={
                          this.state.mitigatedHistogramResponse
                        }
                        title="Post-Mitigated - Threat"
                      />
                    </div>
                  </div>
                </div>

                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>New Scenario - Threat</b>
                      </h4>
                    </div>
                    <div className="chartCont">
                      <HistogramChart
                        {...this.props}
                        isOpportunity={false}
                        histogramResponse={
                          this.state.nonMitigatedMonteCarloResponse
                        }
                        title="New Scenario - Threat"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="wBox">
                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>Realised - Opportunity</b>
                      </h4>
                    </div>
                    <div className="chartCont">
                      <HistogramChart
                        {...this.props}
                        isOpportunity={true}
                        histogramResponse={
                          this.state.nonmitigatedHistogramResponseOpportunity
                        }
                        title="Realised - Opportunity"
                      />
                    </div>
                  </div>
                </div>
                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>New Scenario - Opportunity</b>
                      </h4>
                    </div>
                    <div className="chartCont">
                      <HistogramChart
                        {...this.props}
                        isOpportunity={true}
                        histogramResponse={
                          this.state.mitigatedHistogramResponseOpportunity
                        }
                        title="New Scenario - Opportunity"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="wBox_tornodoChart"> */}
              <div className="wBox">
                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>
                        Post-Mitigated - Threat : Probability and Impact ranking
                        </b>
                        {this.state.Impact
                          ? " - (" +
                            this.state.Impact.name +
                            " / " +
                            this.state.Impact.units +
                            ")"
                          : ""}
                      </h4>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                      <RadioGroup
                        aria-label="post-mitigated-threat-tornado-option"
                        name="post-mitigated-threat-tornado-option"
                        value={this.state.postMitigatedThreatTornadoOption}
                        onChange={(e) => this.setState({ postMitigatedThreatTornadoOption: e.target.value })}
                        row
                      >
                         <FormControlLabel
                          value="all"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                        />

                        <FormControlLabel
                          value="top10"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                        />

                      </RadioGroup>
                    </div>
                    <div className="chartCont tornodoAnalyticsChart">
                      <TornadoChart
                        {...this.props}
                        isOpportunity={false}
                        tornodoResponse={this.getFilteredTornadoData(
                          this.state.mitigatedTornodoResponse,
                          this.state.postMitigatedThreatTornadoOption
                        )}
                        title={`Post-Mitigated - Threat : Probability and Impact ranking${this.state.Impact ? " - (" + this.state.Impact.name + " / " + this.state.Impact.units + ")" : ""}`}
                      />
                    </div>
                  </div>
                </div>

                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>
                        New Scenario - Threat : Probability and Impact ranking
                        </b>
                        {this.state.Impact
                          ? " - (" +
                            this.state.Impact.name +
                            " / " +
                            this.state.Impact.units +
                            ")"
                          : ""}
                      </h4>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                      <RadioGroup
                        aria-label="new-scenario-threat-tornado-option"
                        name="new-scenario-threat-tornado-option"
                        value={this.state.newScenarioThreatTornadoOption}
                        onChange={(e) => this.setState({ newScenarioThreatTornadoOption: e.target.value })}
                        row
                      >
                        <FormControlLabel
                          value="all"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                        />
                        <FormControlLabel
                          value="top10"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                        />
                        
                      </RadioGroup>
                    </div>
                    <div className="chartCont tornodoAnalyticsChart">
                      <TornadoChart
                        {...this.props}
                        isOpportunity={false}
                        tornodoResponse={this.getFilteredTornadoData(
                          this.state.nonmitigatedTornodoResponse,
                          this.state.newScenarioThreatTornadoOption
                        )}
                        title={`New Scenario - Threat : Probability and Impact ranking${this.state.Impact ? " - (" + this.state.Impact.name + " / " + this.state.Impact.units + ")" : ""}`}
                      />
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </div>

              {/* <div className="wBox_tornodoChart"> */}
              <div className="wBox">
                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>
                        Realised - Opportunity : Probability and Impact ranking
                        </b>
                        {this.state.Impact
                          ? " - (" +
                            this.state.Impact.name +
                            " / " +
                            this.state.Impact.units +
                            ")"
                          : ""}
                      </h4>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                      <RadioGroup
                        aria-label="realised-opportunity-tornado-option"
                        name="realised-opportunity-tornado-option"
                        value={this.state.realisedOpportunityTornadoOption}
                        onChange={(e) => this.setState({ realisedOpportunityTornadoOption: e.target.value })}
                        row
                      >
                       <FormControlLabel
                          value="all"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                        />
                        <FormControlLabel
                          value="top10"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                        />
                         
                      </RadioGroup>
                    </div>
                    <div className="chartCont tornodoAnalyticsChart">
                      <TornadoChart
                        {...this.props}
                        isOpportunity={true}
                        tornodoResponse={this.getFilteredTornadoData(
                          this.state.nonmitigatedTornodoResponseOpportunity,
                          this.state.realisedOpportunityTornadoOption
                        )}
                        title={`Realised - Opportunity : Probability and Impact ranking${this.state.Impact ? " - (" + this.state.Impact.name + " / " + this.state.Impact.units + ")" : ""}`}
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="wGrid_tornodoChart"> */}
                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>
                        New Scenario - Opportunity : Probability and Impact ranking
                        </b>
                        {this.state.Impact
                          ? " - (" +
                            this.state.Impact.name +
                            " / " +
                            this.state.Impact.units +
                            ")"
                          : ""}
                      </h4>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                      <RadioGroup
                        aria-label="new-scenario-opportunity-tornado-option"
                        name="new-scenario-opportunity-tornado-option"
                        value={this.state.newScenarioOpportunityTornadoOption}
                        onChange={(e) => this.setState({ newScenarioOpportunityTornadoOption: e.target.value })}
                        row
                      >
                       <FormControlLabel
                          value="all"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                        />
                        <FormControlLabel
                          value="top10"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                        />
                         
                      </RadioGroup>
                    </div>
                    <div className="chartCont tornodoAnalyticsChart">
                      <TornadoChart
                        {...this.props}
                        isOpportunity={true}
                        tornodoResponse={this.getFilteredTornadoData(
                          this.state.mitigatedTornodoResponseOpportunity,
                          this.state.newScenarioOpportunityTornadoOption
                        )}
                        title={`New Scenario - Opportunity : Probability and Impact ranking${this.state.Impact ? " - (" + this.state.Impact.name + " / " + this.state.Impact.units + ")" : ""}`}
                      />
                    </div>
                  </div>
                </div>
                {/* </div> */}
                {/* </div> */}
              </div>

              <div className="wBox">
                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>
                        Post-Mitigated - Threat : Tornado
                        </b>
                        {this.state.Impact
                          ? " - (" +
                            this.state.Impact.name +
                            " / " +
                            this.state.Impact.units +
                            ")"
                          : ""}
                      </h4>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                      <RadioGroup
                        aria-label="post-mitigated-threat-full-tornado-option"
                        name="post-mitigated-threat-full-tornado-option"
                        value={this.state.postMitigatedThreatFullTornadoOption}
                        onChange={(e) => this.setState({ postMitigatedThreatFullTornadoOption: e.target.value })}
                        row
                      >
                       <FormControlLabel
                          value="all"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                        />
                        <FormControlLabel
                          value="top10"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                        />
                         
                      </RadioGroup>
                    </div>
                    <div className="chartCont">
                      <FullTornadoChart
                        {...this.props}
                        isOpportunity={false}
                        tornodoResponse={this.getFilteredFullTornadoData(
                          this.state.nonMitigatedFullTornodoResponses,
                          this.state.postMitigatedThreatFullTornadoOption
                        )}
                        title={`Post-Mitigated - Threat : Tornado${this.state.Impact ? " - (" + this.state.Impact.name + " / " + this.state.Impact.units + ")" : ""}`}
                      />
                    </div>
                  </div>
                </div>

                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>
                        New Scenario - Threat : Tornado
                        </b>
                        {this.state.Impact
                          ? " - (" +
                            this.state.Impact.name +
                            " / " +
                            this.state.Impact.units +
                            ")"
                          : ""}
                      </h4>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                      <RadioGroup
                        aria-label="new-scenario-threat-full-tornado-option"
                        name="new-scenario-threat-full-tornado-option"
                        value={this.state.newScenarioThreatFullTornadoOption}
                        onChange={(e) => this.setState({ newScenarioThreatFullTornadoOption: e.target.value })}
                        row
                      >
                       <FormControlLabel
                          value="all"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                        />
                        <FormControlLabel
                          value="top10"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                        />
                         
                      </RadioGroup>
                    </div>
                    <div className="chartCont">
                      <FullTornadoChart
                        {...this.props}
                        isOpportunity={false}
                        tornodoResponse={this.getFilteredFullTornadoData(
                          this.state.mitigatedFullTornodoResponses,
                          this.state.newScenarioThreatFullTornadoOption
                        )}
                        title={`New Scenario - Threat : Tornado${this.state.Impact ? " - (" + this.state.Impact.name + " / " + this.state.Impact.units + ")" : ""}`}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="wBox">
                <div className="wGrid">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>
                        Realised - Opportunity : Tornado
                        </b>
                        {this.state.Impact
                          ? " - (" +
                            this.state.Impact.name +
                            " / " +
                            this.state.Impact.units +
                            ")"
                          : ""}
                      </h4>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                      <RadioGroup
                        aria-label="realised-opportunity-full-tornado-option"
                        name="realised-opportunity-full-tornado-option"
                        value={this.state.realisedOpportunityFullTornadoOption}
                        onChange={(e) => this.setState({ realisedOpportunityFullTornadoOption: e.target.value })}
                        row
                      >
                        <FormControlLabel
                          value="all"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                        />
                        <FormControlLabel
                          value="top10"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                        />
                        
                      </RadioGroup>
                    </div>
                    <div className="chartCont">
                      <FullTornadoChart
                        {...this.props}
                        isOpportunity={true}
                        tornodoResponse={this.getFilteredFullTornadoData(
                          this.state.nonMitigatedOppFullTornodoResponses,
                          this.state.realisedOpportunityFullTornadoOption
                        )}
                        title={`Realised - Opportunity : Tornado${this.state.Impact ? " - (" + this.state.Impact.name + " / " + this.state.Impact.units + ")" : ""}`}
                      />
                    </div>
                  </div>
                </div>

                <div className="wGrid ">
                  <div className="wGBox">
                    <div className="wgHeader">
                      <h4>
                        <b>
                        New Scenario - Opportunity : Tornado
                        </b>
                        {this.state.Impact
                          ? " - (" +
                            this.state.Impact.name +
                            " / " +
                            this.state.Impact.units +
                            ")"
                          : ""}
                      </h4>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                      <RadioGroup
                        aria-label="new-scenario-opportunity-full-tornado-option"
                        name="new-scenario-opportunity-full-tornado-option"
                        value={this.state.newScenarioOpportunityFullTornadoOption}
                        onChange={(e) => this.setState({ newScenarioOpportunityFullTornadoOption: e.target.value })}
                        row
                      >
                         <FormControlLabel
                          value="all"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                        />
                        <FormControlLabel
                          value="top10"
                          control={<Radio size="small" style={{color: "white"}} />}
                          label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                        />
                       
                      </RadioGroup>
                    </div>
                    <div className="chartCont">
                      <FullTornadoChart
                        {...this.props}
                        isOpportunity={true}
                        tornodoResponse={this.getFilteredFullTornadoData(
                          this.state.mitigatedOppFullTornodoResponses,
                          this.state.newScenarioOpportunityFullTornadoOption
                        )}
                        title={`New Scenario - Opportunity : Tornado${this.state.Impact ? " - (" + this.state.Impact.name + " / " + this.state.Impact.units + ")" : ""}`}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="gbox impactGbox" id="rw-tab-header">
                <div className="header">
                  <h2>Impact </h2>
                  <ul>
                    <li>
                      <DropDownList
                        data={this.Percentile}
                        defaultValue="Percentile"
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            Percentile: e.target.value,
                          })
                        }
                      />
                    </li>

                    <li onClick={this.runMonteCarleForGrid}>
                      <button>Run Monte Carlo</button>
                    </li>
                  </ul>
                </div>
                <div className="dataGrids impactTbl">
                  <Grid
                    data={this.state.impactGridData}
                    reorderable
                    resizable
                    sortable={true}
                  >
                    <Column field="impactName" title="Impact" width="150" />
                    <Column
                      field="current"
                      title="Post-Mitigated Threat"
                      width="50px"
                      cell={(props) => <CurrencyFormat {...props} />}
                    />

                    <Column
                      field="revised"
                      title="New Scenario Threat"
                      width="50px"
                      cell={(props) => <CurrencyFormat {...props} />}
                    />
                    <Column
                      field="oppCurrent"
                      width="50px"
                      title="Realised Opportunity"
                      cell={(props) => <CurrencyFormat {...props} />}
                    />
                    <Column
                      field="oppRevised"
                      width="50px"
                      title="New Scenario Opportunity"
                      cell={(props) => <CurrencyFormat {...props} />}
                    />
                    {/* <Column field="percentage" title="Percentage"  /> */}
                  </Grid>
                </div>
                <div className="btnGroups">
                  <button onClick={this.openScenarioPopup}>
                    {this.state.editFlag ? "Update Scenario" : "Save Scenario"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Popup
          show={this.state.openScenarioModelFlag}
          popupClass={"popup-content"}
        >
          <div className="deleteModelCont">
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <h5>Scenario</h5>
            <div class="formContainers">
              <input
                name="scenarioname"
                type="text"
                placeholder="Name"
                autoComplete="off"
                value={this.state.Name}
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    Name: e.target.value,
                  });
                }}
              />
              <textarea
                name="scenarioDescription"
                placeholder="Description"
                autoComplete="off"
                value={this.state.Description}
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    Description: e.target.value,
                  });
                }}
              ></textarea>
            </div>
            <div className="btnCont">
              <button
                disabled={!this.state.Name}
                onClick={
                  this.state.editFlag ? this.updateScenario : this.saveScenaio
                }
                className="deleteBtn"
                type="button"
              >
                {this.state.editFlag ? "UPDATE" : "SAVE"}
              </button>
              <button
                onClick={this.closeScenarioPopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        <Popup
          show={this.state.openDeleteModelFlagView}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this scenario?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.removeScenario()}
                className="deleteBtn"
                type="button"
              >
                Delete
              </button>
              <button
                onClick={this.closeDeletePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
export default Scenario;
